import {
  DEFAULT_ANIMATE_DURATION,
  NextImage,
  noForwardProps
} from '@apeiron/temp'
import { Box, styled } from '@mui/material'

const Container = styled(Box)`
  position: relative;
  width: 100%;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;

  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const Image = styled(NextImage, noForwardProps)<{
  __aspectRatio: string
  __mobileAspectRatio?: string
}>`
  aspect-ratio: ${props => props.__aspectRatio};
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('res768')} {
    aspect-ratio: ${props => props.__mobileAspectRatio ?? props.__aspectRatio};
  }
`

type Props = {
  imgSrc: string
  aspectRatio: string
  mobileAspectRatio?: string
}

const ImageBlockView = ({ imgSrc, aspectRatio, mobileAspectRatio }: Props) => {
  return (
    <Container>
      <Image
        src={imgSrc}
        __aspectRatio={aspectRatio}
        __mobileAspectRatio={mobileAspectRatio}
      />
    </Container>
  )
}

export default ImageBlockView
